import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import {
  formatDateString,
  getShipmentCreatedAt,
} from "./fulfillment-group-csv-utils";

export const ShipmentCreatedAtCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Shipment created at",
    cell: (row) => {
      return formatDateString(getShipmentCreatedAt(row)?.toISOString() ?? "");
    },
  };
